<style lang="sass" scoped>
  .pie
    margin-top: 80px

  .bar
    margin-top: 12px

  .card-body
    padding: 24px
    min-height: 350px

    .loader
      position: absolute
      top: 50%
      left: 50%
      margin-top: -30px
      margin-left: -30px
      width: 60px
      height: 60px

    .fake
      opacity: 0.9

      &.hovering // Lower opacity and no pointer events when hovering
        pointer-events: none
        opacity: 0.1
</style>

<template>
  <div
    class="card with-shadow"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div class="card-body">
      <FakeData
        :hovering="hovering"
        cta="SAIBA MAIS SOBRE A ORIGEM DE SEUS LEADS"
        href="https://salesflowcrm.movidesk.com/kb/article/404709/como-o-salesflow-identifica-a-origem-do-lead"
        content="Utilize o analytics do Bulldesk para saber exatamente como seus leads encontram você."
        v-if="fake"
      />
      <DashboardEmptyData v-else-if="empty" />
      <div
        class="data"
        :class="{ disabled: loading, fake, hovering, hidden: empty }"
      >
        <div class="row">
          <div class="col-9 bar">
            <ReportChart
              type="bar"
              height="350"
              source="lead.origin"
              :timeseries="true"
              :range="range"
              :stacked="true"
              :title="__('Leads por origem')"
              :imports="imports"
              v-model="data"
              @fake="setFake"
              @empty="setEmpty"
              :fake-data="barFakeData"
            />
          </div>
          <div class="col-3 pie">
            <ReportChart
              type="donut"
              height="300"
              source="lead.origin"
              :range="range"
              :legend="false"
              :imports="imports"
              :fake-data="pieFakeData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'range', 'imports'],

  data () {
    return {
      loading: true,
      fake: false,
      empty: false,
      hovering: false,
      barFakeData: {
        total: 223, series: [{ name: 'Google Adwords', data: [10, 10, 9, 9, 9, 8, 7, 7, 6, 6, 5, 5, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 0, 3, 3, 1, 2, 1, 0, 1] }, { name: 'Direto', data: [1, 1, 1, 2, 1, 1, 0, 2, 0, 0, 5, 2, 4, 0, 1, 0, 0, 0, 0, 0, 1, 0, 2, 2, 0, 1, 1, 2, 0, 0] }, { name: 'Google', data: [5, 0, 5, 1, 1, 2, 1, 2, 0, 1, 0, 3, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 4, 3, 1, 2, 0, 1, 2, 0] }, { name: 'Interno', data: [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0] }, { name: 'Google Ads', data: [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0] }, { name: 'Instagram Ads', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0] }, { name: 'Indica\u00e7\u00e3o', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { name: 'DuckDuckGo', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }], categories: ['2019-12-05', '2019-12-10', '2019-12-06', '2019-12-09', '2019-12-19', '2019-12-17', '2019-12-16', '2019-12-18', '2019-12-22', '2019-12-26', '2019-12-04', '2019-12-11', '2019-12-12', '2019-12-15', '2019-12-20', '2019-12-21', '2019-12-01', '2019-12-07', '2019-12-13', '2019-12-23', '2019-12-24', '2019-12-27', '2019-12-30', '2019-12-02', '2019-12-08', '2019-12-03', '2019-12-14', '2019-12-28', '2019-12-29', '2019-12-25'], colors: ['#7123DB', '#7123DB', '#F60454', '#FF7F00', '#FF00FF', '#137AEE', '#00ECA2', '#00D5DD', '#00B9FF'], labeled: { series: [146, 30, 37, 4, 2, 1, 1, 1, 1], labels: ['Google Adwords', 'Direto', 'Google', 'Interno', 'Google Ads', 'Instagram Ads', 'Rodrigo Maciel', 'Indica\u00e7\u00e3o', 'DuckDuckGo'] },
      },
      pieFakeData: {
        total: 223, series: [{ name: 'Google Adwords', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 146] }, { name: 'Google', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 37] }, { name: 'Direto', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30] }, { name: 'Interno', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4] }, { name: 'Google Ads', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2] }, { name: 'Instagram Ads', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1] }, { name: 'Indica\u00e7\u00e3o', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1] }, { name: 'DuckDuckGo', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1] }], categories: ['Google Adwords', 'Google', 'Direto', 'Rodrigo Maciel', 'Interno', 'Google Ads', 'Instagram Ads', 'Indica\u00e7\u00e3o', 'DuckDuckGo'], colors: ['#7123DB', '#F60454', '#7123DB', '#00ECA2', '#FF7F00', '#FF00FF', '#137AEE', '#00D5DD', '#00B9FF'], labeled: { series: [146, 37, 304, 2, 1, 1, 1, 1], labels: ['Google Adwords', 'Google', 'Direto', 'Interno', 'Google Ads', 'Instagram Ads', 'Indica\u00e7\u00e3o', 'DuckDuckGo'] },
      },
      data: {},
    };
  },

  watch: {
    data (data) {
      this.loading = false;
    },
  },

  methods: {
    setEmpty (empty) {
      this.empty = empty;
    },

    setFake (fake) {
      this.fake = fake;
    },
  },
};
</script>
